import React from "react";
import "./CoConnectHub.css";
import "./AssessHub.css";

export default function AssessHub({ setCurrentView }) {
  return (
    <div className="cch-container">
      <img
        src={(process.env.PUBLIC_URL || "") + "/Icon-WHA-Blue.png"}
        alt="Logo"
        style={{
          width: "100%",
          maxWidth: 200,
          height: "auto",
          display: "block",
          margin: "-50px auto 0 auto",
        }}
      />
      <h1 className="cch-title">Step 1 - Assess</h1>
      <p className="cch-subtitle">
        Start by completing your Wholistic Health Assessment © and entering your
        latest lab results.
      </p>

      <div className="cch-pillars assess-pillars">
        <div
          className="cch-card assess-card"
          onClick={() => setCurrentView("Assessment")}
        >
          <img
            className="assess-card-icon"
            src={(process.env.PUBLIC_URL || "") + "/Icon-WHA-Blue.png"}
            alt="Wholistic Health Assessment icon"
          />
          <h2 className="cch-card-title">Wholistic Health Assessment ©</h2>
          <p className="cch-card-text">
            Complete your assessment to capture a full picture of your current
            well-being.
          </p>
          <button className="cch-button assess-card-button">
            Open Assessment
          </button>
        </div>

        <div
          className="cch-card assess-card"
          onClick={() => setCurrentView("LabResultsAssessment")}
        >
          <img
            className="assess-card-icon"
            src={(process.env.PUBLIC_URL || "") + "/Icon-Lab-Blue.png"}
            alt="Enter Lab Results icon"
          />
          <h2 className="cch-card-title">Enter Lab Results</h2>
          <p className="cch-card-text">
            Add your most recent lab values so your reports and progress views
            stay current.
          </p>
          <button className="cch-button assess-card-button">
            Enter Lab Results
          </button>
        </div>
      </div>
    </div>
  );
}
